var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleWestend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11566_37244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.1659C15.0617 19.1659 19.165 15.0626 19.165 10.0009C19.165 4.93925 15.0617 0.835938 9.99996 0.835938C4.93827 0.835938 0.834961 4.93925 0.834961 10.0009C0.834961 15.0626 4.93827 19.1659 9.99996 19.1659Z",
    fill: "#E6007A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.1659C15.0617 19.1659 19.165 15.0626 19.165 10.0009C19.165 4.93925 15.0617 0.835938 9.99996 0.835938C4.93827 0.835938 0.834961 4.93925 0.834961 10.0009C0.834961 15.0626 4.93827 19.1659 9.99996 19.1659Z",
    fill: "url(#paint0_linear_11566_37244)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4376 6.97701C12.0103 6.76968 11.4983 6.66602 10.9014 6.66602H6.91504V13.7341H8.93179V11.576H10.9014C11.4983 11.576 12.0103 11.4754 12.4376 11.2744C12.8711 11.0671 13.204 10.7812 13.4365 10.4168C13.669 10.0461 13.7852 9.61261 13.7852 9.11628C13.7852 8.62623 13.669 8.199 13.4365 7.8346C13.204 7.46392 12.8711 7.17806 12.4376 6.97701ZM8.93179 9.96444H10.7883C11.0899 9.96444 11.3255 9.88905 11.4951 9.73827C11.6648 9.58748 11.7496 9.38015 11.7496 9.11628C11.7496 8.8524 11.6648 8.64821 11.4951 8.50371C11.3255 8.35293 11.0899 8.27753 10.7883 8.27753H8.93179V9.96444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4173 3.7007C11.4173 4.48357 10.7826 5.1182 9.99978 5.1182C9.21692 5.1182 8.58228 4.48357 8.58228 3.7007C8.58228 2.91784 9.21692 2.2832 9.99978 2.2832C10.7826 2.2832 11.4173 2.91784 11.4173 3.7007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4173 16.3007C11.4173 17.0836 10.7826 17.7182 9.99978 17.7182C9.21692 17.7182 8.58228 17.0836 8.58228 16.3007C8.58228 15.5178 9.21692 14.8832 9.99978 14.8832C10.7826 14.8832 11.4173 15.5178 11.4173 16.3007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1644 8.0787C15.4864 8.47014 14.6195 8.23784 14.228 7.55986C13.8366 6.88188 14.0689 6.01495 14.7469 5.62352C15.4249 5.23209 16.2918 5.46438 16.6832 6.14236C17.0747 6.82034 16.8424 7.68727 16.1644 8.0787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25247 14.3787C4.57449 14.7701 3.70756 14.5378 3.31613 13.8599C2.92469 13.1819 3.15699 12.315 3.83497 11.9235C4.51295 11.5321 5.37988 11.7644 5.77131 12.4424C6.16274 13.1203 5.93045 13.9873 5.25247 14.3787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83496 8.0787C4.51294 8.47013 5.37987 8.23784 5.7713 7.55986C6.16274 6.88188 5.93044 6.01495 5.25246 5.62352C4.57448 5.23208 3.70755 5.46438 3.31612 6.14236C2.92469 6.82034 3.15698 7.68727 3.83496 8.0787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7469 14.3787C15.4249 14.7701 16.2918 14.5378 16.6832 13.8599C17.0747 13.1819 16.8424 12.3149 16.1644 11.9235C15.4864 11.5321 14.6195 11.7644 14.228 12.4424C13.8366 13.1203 14.0689 13.9873 14.7469 14.3787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11566_37244",
    x1: 1.27048,
    y1: 9.47721,
    x2: 31.0031,
    y2: 9.49955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79420",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11566_37244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleWestend);
export default __webpack_public_path__ + "static/media/people-westend.16b9da7cc0f441b30d61ac31e4078c0f.svg";
export { ForwardRef as ReactComponent };